
import './App.css';
import HanumanModern from './HanumanModern';

function App() {
  return <HanumanModern />;
}

export default App;
